import { render, staticRenderFns } from "./vertical-editor.vue?vue&type=template&id=35934906&scoped=true"
import script from "./vertical-editor.vue?vue&type=script&lang=js"
export * from "./vertical-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35934906",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35934906')) {
      api.createRecord('35934906', component.options)
    } else {
      api.reload('35934906', component.options)
    }
    module.hot.accept("./vertical-editor.vue?vue&type=template&id=35934906&scoped=true", function () {
      api.rerender('35934906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-slider/vertical-editor.vue"
export default component.exports